import { Box, FlexBox, Text } from '@trmediaab/zebra';

import Img from '~/components/Img';
import { ThemedLink } from '~/components/ThemedLink';

import Breadcrumb from './Breadcrumb';
import { buildArticleLink, getBetTypeColor, getMetaLabels } from './utils';

export default function ChronicleTeaser({ data, round }) {
  const [author] = data.authors;

  let name = '';
  if (author.firstname && author.lastname) {
    name = `${author.firstname} ${author.lastname}`;
  } else if (author.lastname) {
    name = `${author.lastname}`;
  } else if (typeof author === 'string') {
    name = `${author}`;
  }

  return (
    <Box>
      <ThemedLink
        to={buildArticleLink(data)}
        sx={{
          "&:hover [data-id='headline'] ": {
            textDecoration: 'underline',
          },
        }}
      >
        <FlexBox bg="white" alignItems="flex-end">
          <FlexBox
            flexDirection="column"
            flex={1}
            minHeight={{ _: 64, md: 120 }}
            px={{ _: 3, md: '3,5' }}
            py={{ _: 3, md: '3,5' }}
            gap={{ _: 1, md: 2 }}
          >
            <Breadcrumb
              type={data.type}
              meta={getMetaLabels(data.round)}
              color={getBetTypeColor(data, round)}
            />

            <Text
              fontSize={{ _: 3, md: 5 }}
              lineHeight="medium"
              fontWeight="bold"
              color="black"
              data-id="headline"
            >
              <Text color="greys.3" mr="2" display="inline-block">
                {name}
              </Text>

              {data.teaser_headline || data.headline}
            </Text>

            <Text
              display={{ _: 'none', md: 'block' }}
              fontSize={{ _: 1, md: 2 }}
              color="greys.6"
            >
              {data.teaser || data.preamble}
            </Text>
          </FlexBox>

          <Box display={{ _: 'block', md: 'none' }}>
            <Img
              width={64}
              aspectRatio={[1, 1]}
              image={data.authors[0].image}
            />
          </Box>

          <Box display={{ _: 'none', md: 'block' }}>
            <Img
              width={120}
              aspectRatio={[1, 1]}
              image={data.authors[0].image}
            />
          </Box>
        </FlexBox>
      </ThemedLink>
    </Box>
  );
}
